<template>
  <div>
    <!-- <Header /> -->
    <confirmPopup
      v-if="popupwindow == true"
      :title="titlepass"
      @cancelClick="popupwindow = false"
      @confirmClick="QuizDeleted(deleteId)"
    />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <confirmPopup
      v-if="popupwindowquestiondelete != null"
      :title="titlepass"
      @cancelClick="popupwindowquestiondelete = null"
      @confirmClick="removeQuestion(popupwindowquestiondelete)"
    />
    <div class="flex">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <div class="flex flex-col h-full" v-if="this.is_selected == 'list'">
          <div
            class="flex flex-wrap gap-4 items-center justify-between px-5 lg:px-10 pt-10"
          >
            <div>
              <h1 class="text-lg font-semibold">Assessment</h1>
            </div>
            <div class="flex gap-3">
              <router-link
                :to="{ name: 'AssessmentOverallFeedback' }"
                class="bg-blues text-white font-semibold text-xs px-4 py-2 rounded-xl hover:bg-blue-700 transition duration-300 ease-in-out"
              >
                Feedback
              </router-link>
              <button
                v-if="active_tab === 'Course Quiz'"
                @click="this.addQuiz = true"
                class="bg-blues text-white font-semibold text-xs px-4 py-2 rounded-xl hover:bg-blue-700 transition duration-300 ease-in-out"
              >
                Add Assessment
              </button>
              <button
                v-if="active_tab === 'Lesson Quiz'"
                @click="this.addLessonQuiz = true"
                class="bg-blues text-white font-semibold text-xs px-4 py-2 rounded-xl hover:bg-blue-700 transition duration-300 ease-in-out"
              >
                Add Assessment
              </button>
            </div>
          </div>
          <div class="px-2 lg:px-10 py-5" v-if="response_message">
            <div
              class="w-full bg-green-50 border border-green-200 flex justify-between items-center px-4 py-3 rounded-xl shadow-sm"
            >
              <h2 class="text-green-700 font-semibold text-sm">
                {{ response_message }}
              </h2>

              <router-link
                :to="{ name: 'DownloadHistory' }"
                class="text-green-600 text-xs underline font-bold"
              >
                Download History
              </router-link>
            </div>
          </div>

          <div class="flex flex-col md:flex-row justify-between w-full">
            <div class="flex items-center gap-5 px-5 lg:px-10 pt-6 pb-3 w-full">
              <button
                @click="
                  (typeQuiz = 'course'), quizgetinfo();
                  this.active_tab = 'Course Quiz';
                "
                :class="
                  this.active_tab == 'Course Quiz'
                    ? 'bg-blues text-white'
                    : 'text-black bg-gray-100 hover:bg-slate-300'
                "
                class="font-semibold text-xs px-4 py-2 rounded-xl"
              >
                Module Assessment
              </button>
              <button
                @click="
                  (typeQuiz = 'lesson'), quizgetinfo();
                  this.active_tab = 'Lesson Quiz';
                "
                :class="
                  this.active_tab == 'Lesson Quiz'
                    ? 'bg-blues text-white'
                    : 'text-black bg-gray-100  hover:bg-slate-300'
                "
                class="font-semibold text-xs px-4 py-2 rounded-xl"
              >
                Lesson Quiz
              </button>
            </div>
            <div class="flex justify-end w-full px-10 py-5">
              <div class="relative">
                <form @submit.prevent="quizgetinfo()">
                  <input
                    type="text"
                    placeholder="Search"
                    id="search"
                    v-model="quizsearch"
                    @input="quizgetinfo()"
                    class="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-300 hover:bg-gray-100 transition-all duration-200"
                  />
                  <button type="submit" class="">
                    <div class="absolute right-3 top-2.5 h-5 w-5 text-gray-400">
                      <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                    </div>
                  </button>
                </form>
              </div>
              <div
                @click="downloadFile"
                class="mt-3 px-3 cursor-pointer"
                v-if="
                  (typeQuiz === 'lesson' && generalquiz.length > 0) ||
                  (typeQuiz === 'course' && generalquiz.length > 0)
                "
              >
                <img
                  v-if="loading"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />

                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  height="24px"
                  viewBox="0 -960 960 960"
                  width="24px"
                  fill="#0000F5"
                >
                  <path
                    d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z"
                  />
                </svg>
              </div>
            </div>
          </div>

          <div v-if="loading" class="flex flex-col justify-center h-screen">
            <div class="flex justify-center">
              <img src="@/assets/newd/loading.gif" alt="" />
            </div>
          </div>

          <div
            v-else-if="(this.generalquiz.length > 0) & !loading"
            class="flex flex-col gap-10 px-5 lg:px-10 pt-5 pb-10 w-full"
          >
            <!-- Dynamic Title Section -->
            <div class="flex items-center justify-between w-full border-b pb-3">
              <h1 class="text-md lg:text-xl font-bold text-gray-800">
                {{
                  active_tab === "Course Quiz" ? "Course Quiz" : "Lesson Quiz"
                }}
              </h1>
              <p class="text-gray-600 text-base font-medium">
                Total:
                <span class="text-blue-600 font-semibold">{{
                  generalquiz.length
                }}</span>
              </p>
            </div>

            <!-- <pre>{{ generalquiz }}</pre> -->
            <draggable
              v-model="generalquiz"
              item-key="quiz.quiz.id"
              class="dragArea list-group w-full"
              @change="handleQuizOrderChange"
              :animation="200"
              handle=".drag-handle-quiz"
              ghost-class="ghost"
              chosen-class="chosen"
              :force-fallback="true"
              :scroll-sensitivity="80"
              :scroll-speed="2"
              :bubble-scroll="true"
            >
              <transition-group tag="div" type="transition" class="flip-list">
                <div
                  v-for="(quiz, index) in generalquiz"
                  :key="quiz.quiz.id"
                  class="group p-5 lg:p-10 flex items-center gap-5 lg:gap-10 w-full border rounded-2xl hover:bg-gray-50 transition mb-5 last:mb-0"
                >
                  <div
                    class="flex flex-col gap-2 lg:gap-0 lg:flex-row md:flex-row items-center justify-between w-full"
                  >
                    <div
                      class="flex flex-col md:flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-10 w-full relative"
                    >
                      <div class="relative">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                          class="w-6 h-6 text-gray-600 cursor-move drag-handle-quiz"
                          title="Drag to reorder quizzes"
                        >
                          <circle cx="5" cy="5" r="1.5" />
                          <circle cx="12" cy="5" r="1.5" />
                          <circle cx="5" cy="12" r="1.5" />
                          <circle cx="12" cy="12" r="1.5" />
                          <circle cx="5" cy="19" r="1.5" />
                          <circle cx="12" cy="19" r="1.5" />
                        </svg>
                      </div>

                      <!-- Quiz Icon -->
                      <div class="flex items-center gap-3 w-full md:w-auto">
                        <img
                          src="@/assets/new/assignment.png"
                          class="rounded-xl w-full sm:w-1/2 md:w-1/3 lg:w-auto"
                          alt="quiz"
                        />
                      </div>

                      <!-- Quiz Details -->
                      <div class="flex flex-col gap-2 w-full">
                        <!-- Quiz Name Edit Section -->
                        <div
                          v-if="editQuizId !== quiz.quiz.id"
                          class="flex gap-3 items-center"
                        >
                          <h1 class="text-gray-700 text-base font-bold">
                            {{ quiz.quiz.name }}
                          </h1>
                          <img
                            @click="editId(quiz.quiz.id)"
                            src="@/assets/edit.svg"
                            alt="edit"
                            class="object-contain w-5 h-5 sm:w-6 sm:h-6 cursor-pointer flex-shrink-0"
                          />
                        </div>

                        <!-- Edit Quiz Name Form -->
                        <form
                          v-if="editQuizId == quiz.quiz.id"
                          @submit.prevent="PostData(quiz.quiz.id)"
                          class="flex flex-wrap items-center gap-3"
                        >
                          <input
                            v-if="quizdetailsget.lesson_quize == false"
                            class="border px-3 py-1"
                            type="text"
                            v-model="quizdetailsget.name"
                            required
                            autofocus
                          />
                          <input
                            v-else
                            class="border px-3 py-1"
                            type="text"
                            v-model="quizdetailsget.lesson_title"
                            required
                            autofocus
                          />
                          <div class="flex items-center gap-3">
                            <button
                              type="submit"
                              :disabled="disable_submit == true"
                              :class="
                                this.disable_submit == true
                                  ? 'cursor-not-allowed'
                                  : 'cursor-pointer'
                              "
                            >
                              <img
                                src="@/assets/tick.png"
                                alt="submit"
                                class="object-contain w-6 h-6 cursor-pointer"
                              />
                            </button>
                            <img
                              v-if="disable_submit"
                              src="@/assets/loading.gif"
                              alt="loading"
                              class="w-6 h-6 object-contain"
                            />
                          </div>
                          <button type="button" @click="this.editQuizId = null">
                            <img
                              src="@/assets/close.png"
                              alt="close"
                              class="object-contain w-6 h-6 cursor-pointer"
                            />
                          </button>
                        </form>

                        <!-- Question Count -->
                        <h3
                          class="text-left text-sm px-1 py-1 text-blue-600 font-medium"
                        >
                          {{ quiz.quiz.coursequizquestion_set.length }}
                          Questions
                        </h3>

                        <!-- Quiz Attempt Display -->
                        <div
                          class="flex flex-col gap-1.5"
                          v-if="editAttempt !== quiz.quiz.id"
                        >
                          <p v-if="quiz.quiz.question_attempt" class="text-sm">
                            Multiple Attempt Quiz
                          </p>
                          <p v-if="quiz.quiz.question_attempt" class="text-sm">
                            <b class="font-bold text-blue-600">{{
                              quiz.quiz.question_attempt_count
                            }}</b>
                            Quiz Attempt
                          </p>
                          <div class="flex">
                            <div
                              class="flex items-center gap-2 text-sm py-1 px-3 border text-center justify-center cursor-pointer text-green-800 border-green-800 rounded-xl hover:bg-green-50"
                              @click="editIdAttempt(quiz.quiz.id)"
                            >
                              <img
                                src="@/assets/edit.svg"
                                alt="edit"
                                class="object-contain w-4 h-4 cursor-pointer"
                              />
                              Edit Attempt
                            </div>
                          </div>
                        </div>

                        <!-- Quiz Attempt Edit Form -->
                        <form
                          @submit.prevent="PostDataAttempt(quiz.quiz.id)"
                          class="flex flex-col gap-1.5"
                          v-if="editAttempt == quiz.quiz.id"
                        >
                          <h3 class="text-left text-sm px-1 py-1 font-medium">
                            <input
                              type="checkbox"
                              v-model="quizdetailsget.question_attempt"
                            />
                            Quiz Attempt
                          </h3>

                          <div class="flex items-center gap-2">
                            <input
                              v-if="quizdetailsget.question_attempt"
                              v-model="quizdetailsget.question_attempt_count"
                              class="text-sm px-1 py-1 border"
                              type="number"
                            />
                          </div>

                          <div class="flex items-center gap-3">
                            <button
                              type="submit"
                              class="bg-blue-600 text-sm text-white px-3 py-1 rounded-lg hover:bg-blue-700"
                            >
                              Update
                            </button>
                            <button
                              type="button"
                              @click="editAttempt = null"
                              class="bg-red-600 text-sm text-white px-3 py-1 rounded-lg hover:bg-red-700"
                            >
                              Cancel
                            </button>
                          </div>
                        </form>

                        <!-- Publish Status -->
                        <div class="flex justify-between items-center w-full">
                          <div v-if="quiz.quiz.qualify_certificate == true">
                            <label
                              class="text-left text-sm px-1 py-1 text-green-700 font-medium cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                @click.prevent="
                                  quiz_published(
                                    quiz.quiz.id,
                                    quiz.quiz.name,
                                    quiz.quiz.order,
                                    false,
                                  )
                                "
                                :checked="true"
                              />
                              Published
                            </label>
                          </div>
                          <div v-else>
                            <label
                              class="text-left text-sm px-1 py-1 text-red-700 font-medium cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                @click.prevent="
                                  quiz_published(
                                    quiz.quiz.id,
                                    quiz.quiz.name,
                                    quiz.quiz.order,
                                    true,
                                  )
                                "
                                :checked="false"
                              />
                              Unpublished
                            </label>
                          </div>

                          <!-- Mobile Dropdown Menu -->
                          <div
                            @click="addOperation(quiz.quiz.id)"
                            class="cursor-pointer relative dropdown-container md:hidden"
                          >
                            <img
                              src="@/assets/newd/colon.png"
                              class="hover:bg-gray-300 px-2 py-1 rounded"
                              alt="menu"
                            />
                            <!-- class="flex flex-col gap-3 absolute top-8 right-0 !z-[100] bg-white rounded-lg shadow-lg p-5" -->
                            <div
                              :class="[
                                'absolute right-0 flex flex-col gap-3 bg-white rounded-lg shadow-lg p-5 z-[100] w-48',
                                generalquiz.length > 2 &&
                                index === generalquiz.length - 1
                                  ? 'bottom-8'
                                  : 'top-8',
                              ]"
                              v-if="popUpAction == quiz.quiz.id"
                              @click.self="popUpAction = null"
                            >
                              <button
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                                @click="quizdetailspreview(quiz.quiz.id)"
                              >
                                Preview
                              </button>

                              <button
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                                @click="quizdetailsof_details(quiz.quiz.id)"
                              >
                                Edit
                              </button>

                              <button
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                                @click="quizdetails(quiz.quiz.id)"
                              >
                                Edit Quiz
                              </button>

                              <router-link
                                :to="{
                                  name: 'QuizsScoreboard',
                                  params: {
                                    quiz_id: quiz.quiz.quiztakers_set.quiz.id,
                                    quiz_name:
                                      quiz.quiz.quiztakers_set.quiz.name,
                                  },
                                  query: {
                                    lesson_quize: quiz.quiz.lesson_quize,
                                  },
                                }"
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50 inline-block text-center"
                              >
                                Scoreboard
                              </router-link>

                              <router-link
                                v-if="
                                  quiz.quiz.is_active &&
                                  quiz.quiz.quiz_feedback.total_count != 0
                                "
                                :to="{
                                  name: 'AssessmentSingleFeedback',
                                  params: {
                                    quiz_id: quiz.quiz.id,
                                  },
                                }"
                                class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50 inline-block text-center w-full"
                              >
                                Feedbacks
                              </router-link>

                              <button
                                class="border border-red-400 px-2 rounded flex gap-1 text-sm items-center justify-center py-1 hover:bg-red-100 cursor-pointer text-red-600"
                                @click="
                                  titlepass = quiz.quiz.name;
                                  deleteId = quiz.quiz.id;
                                  popupwindow = true;
                                "
                              >
                                <font-awesome-icon
                                  class="text-base text-red-400 self-center h-3 w-3"
                                  :icon="['fas', 'trash-alt']"
                                />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- shuffle Status -->
                        <div
                          class="flex justify-between items-center w-full cursor-pointer"
                        >
                          <!-- v-if="quiz.quiz.lesson_quize == false" -->
                          <div>
                            <label
                              class="text-left text-sm px-1 py-1 text-green-700 font-medium cursor-pointer"
                            >
                              <input
                                type="checkbox"
                                @click="
                                  editshuffleContent(
                                    quiz.quiz.id,
                                    quiz.quiz.shuffle,
                                  )
                                "
                                v-model="quiz.quiz.shuffle"
                                class="cursor-pointer"
                              />
                              Shuffle
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Desktop Dropdown Menu -->
                    <div
                      @click="addOperation(quiz.quiz.id)"
                      class="cursor-pointer relative dropdown-container hidden md:block"
                    >
                      <img
                        src="@/assets/newd/colon.png"
                        class="hover:bg-gray-300 px-2 py-1 rounded"
                        alt="menu"
                      />
                      <!-- class="flex flex-col gap-3 absolute top-8 right-0 bg-white rounded-lg shadow-lg p-5 !z-[100]" -->
                      <div
                        :class="[
                          'absolute right-0 flex flex-col gap-3 bg-white rounded-lg shadow-lg p-5 z-[100] w-48',
                          generalquiz.length > 2 &&
                          index === generalquiz.length - 1
                            ? 'bottom-8'
                            : 'top-8',
                        ]"
                        v-if="popUpAction == quiz.quiz.id"
                        @click.self="popUpAction = null"
                      >
                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="quizdetailspreview(quiz.quiz.id)"
                        >
                          Preview
                        </button>

                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="quizdetailsof_details(quiz.quiz.id)"
                        >
                          Edit
                        </button>

                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="quizdetails(quiz.quiz.id)"
                        >
                          Edit Quiz
                        </button>

                        <button
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50"
                          @click="duplicateQuiz(quiz.quiz.id)"
                        >
                          Duplicate
                        </button>

                        <router-link
                          :to="{
                            name: 'QuizsScoreboard',
                            params: {
                              quiz_id: quiz.quiz.quiztakers_set.quiz.id,
                              quiz_name: quiz.quiz.quiztakers_set.quiz.name,
                            },
                            query: {
                              lesson_quize: quiz.quiz.lesson_quize,
                            },
                          }"
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50 inline-block text-center"
                        >
                          Scoreboard
                        </router-link>

                        <router-link
                          v-if="
                            quiz.quiz.is_active &&
                            quiz.quiz.quiz_feedback.total_count != 0
                          "
                          :to="{
                            name: 'AssessmentSingleFeedback',
                            params: {
                              quiz_id: quiz.quiz.id,
                            },
                          }"
                          class="border border-gray-200 bg-white px-6 rounded cursor-pointer text-sm py-1 hover:bg-blue-50 inline-block text-center w-full"
                        >
                          Feedbacks
                        </router-link>

                        <button
                          class="border border-red-400 px-2 rounded flex gap-1 text-sm items-center justify-center py-1 hover:bg-red-100 cursor-pointer text-red-600"
                          @click="
                            titlepass = quiz.quiz.name;
                            deleteId = quiz.quiz.id;
                            popupwindow = true;
                          "
                        >
                          <font-awesome-icon
                            class="text-base text-red-400 self-center h-3 w-3"
                            :icon="['fas', 'trash-alt']"
                          />
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>

          <!-- <div v-else class="h-screen flex flex-col justify-center">
            <div class="flex justify-center">
              <img src="@/assets/newd/loading.gif" alt="" />
            </div>
          </div> -->

          <div
            v-if="this.generalquiz.length == 0 && !loading"
            class="h-screen flex flex-col justify-center p-5 lg:p-10 text-center"
          >
            <p>No Data Found</p>
          </div>
        </div>

        <div class="flex flex-col w-full" v-if="this.is_selected == 'preview'">
          <div class="px-3 lg:px-10 mt-10 pb-2">
            <button
              class="bg-blues hover:bg-blue-600 text-xs font-bold text-white px-5 py-1.5 rounded-full"
              @click="this.is_selected = 'list'"
            >
              Back
            </button>
          </div>

          <form
            ref="addQuizRefs"
            @submit.prevent="updateQuizOfSection(quizdetailsget.id)"
            class="px-3 lg:px-10 mt-5 pb-2"
          >
            <div
              v-for="(form, index) in quizdetailsget.questions"
              :key="index"
              class="w-full mt-3 bg-gray-200 rounded-lg p-4"
            >
              <div class="flex flex-col gap-5">
                <div
                  class="flex items-center justify-between bg-primary px-6 py-3 rounded-t-lg w-full"
                >
                  <label class="text-lg text-white"
                    >Question {{ index + 1 }}:</label
                  >
                </div>

                <div class="px-4 sm:px-6 py-2">
                  <textarea
                    v-model="form.question_text"
                    rows="2"
                    required
                    class="p-2 sm:p-4 md:p-4 rounded-md w-full text-sm sm:text-base"
                    placeholder="Enter your question"
                    disabled
                  >
                  </textarea>
                </div>
              </div>

              <div
                class="flex items-center gap-2 px-4 sm:px-6 py-2"
                v-if="quizdetailsget.lesson_quize == true"
              >
                <!-- <input
                  type="radio"
                  value="choice"
                  v-model="form.choice_type"
                  disabled
                />
                Choice Type

                <div>
                  <input
                    type="radio"
                    value="truefalse"
                    v-model="form.choice_type"
                    disabled
                  />
                  True or False
                </div> -->
                <!-- <div>
                  <input
                    type="radio"
                    value="matchthefollowing"
                    v-model="form.choice_type"
                    disabled
                  />
                  Match the following
                </div> -->

                <!-- <input
                  type="radio"
                  value="shortdescription"
                  v-model="form.choice_type"
                  disabled
                />
                Short Answer
                <input
                  type="radio"
                  value="description"
                  v-model="form.choice_type"
                  disabled
                />
                Long Answer -->
              </div>
              <div class="flex items-center gap-2 px-4 sm:px-6 py-2" v-else>
                <input
                  type="radio"
                  value="choice"
                  v-model="form.choice_type"
                  disabled
                />
                Choice Type

                <div>
                  <input
                    type="radio"
                    value="truefalse"
                    v-model="form.choice_type"
                    disabled
                  />
                  True or False
                </div>
                <div>
                  <input
                    type="radio"
                    value="matchthefollowing"
                    v-model="form.choice_type"
                    disabled
                  />
                  Match the following
                </div>

                <input
                  type="radio"
                  value="shortdescription"
                  v-model="form.choice_type"
                  disabled
                />
                Short Answer
                <input
                  type="radio"
                  value="description"
                  v-model="form.choice_type"
                  disabled
                />
                Long Answer
              </div>

              <div
                v-if="form.choice_type == 'choice'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <div
                  v-for="(address, addrIndex) in form.answers"
                  :key="addrIndex"
                  class="flex flex-wrap items-center gap-3 py-2"
                >
                  <label class="text-sm text-gray-700"
                    >Option {{ addrIndex + 1 }}:</label
                  >
                  <input
                    type="text"
                    v-model="address['answer_text']"
                    class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                    placeholder="Enter your option"
                    required
                    disabled
                  />
                  <input
                    type="checkbox"
                    v-model="address['is_correct']"
                    class="w-4 h-4"
                    disabled
                  />
                  <label class="text-sm">Is Answer</label>
                </div>
              </div>

              <div
                v-if="form.choice_type == 'shortdescription'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <input
                  type="number"
                  required
                  v-model="form.max_mark"
                  class="flex-1 border rounded-md p-2 text-sm"
                  placeholder="Add Mark"
                  disabled
                />
              </div>

              <div
                v-if="form.choice_type == 'description'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <input
                  type="number"
                  required
                  v-model="form.max_mark"
                  placeholder="Add Mark"
                  class="flex-1 border rounded-md p-2 text-sm"
                  disabled
                />
              </div>
              <div
                v-if="form.choice_type == 'coding'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <input
                  type="text"
                  disabled
                  v-model="form.programming_language"
                  class="flex-1 border rounded-md p-2 text-sm"
                />
              </div>

              <div
                v-if="form.choice_type == 'matchthefollowing'"
                class="py-3 grid grid-cols-2 gap-2 mt-1 px-6"
              >
                <div>
                  <div
                    v-for="(address, addrIndex) in form.matchthefollowing"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <input
                      type="text"
                      v-model="address.left_text"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter Left Option"
                      required
                      disabled
                    />
                  </div>
                </div>
                <div>
                  <div
                    v-for="(address, addrIndex) in form.matchthefollowing"
                    :key="addrIndex"
                    class="flex flex-wrap items-center gap-3 py-2"
                  >
                    <input
                      type="text"
                      v-model="address.right_text"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter Right Option"
                      required
                      disabled
                    />
                  </div>
                </div>
              </div>

              <div
                v-if="form.choice_type == 'truefalse'"
                class="py-3 flex flex-col gap-2 mt-1 px-6"
              >
                <!-- {{ form.answers }} -->
                <div
                  v-for="(address, addrIndex) in form.truefalse"
                  :key="addrIndex"
                  class="flex flex-wrap items-center gap-3 py-2"
                >
                  <!-- <label class="text-sm text-gray-700"
                      >Option {{ addrIndex + 1 }}:</label
                    > -->
                  <label class="text-sm text-gray-700"> </label>
                  <!-- <input
                      type="text"
                      v-model="address['answer_text']"
                      class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                      placeholder="Enter your option"
                      required
                    /> -->
                  <input
                    type="checkbox"
                    v-model="address['is_correct']"
                    class="w-4 h-4"
                    disabled
                  />
                  <!-- right_text -->
                  <!-- <input
                      type="checkbox"
                      v-model="address['is_correct']"
                      class="w-4 h-4"
                    /> -->
                  <label class="text-sm"
                    ><span v-if="addrIndex == 0">True</span>
                    <span v-else>False</span></label
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- drag and drop -->
        <div class="flex flex-col w-full" v-if="this.is_selected == 'detail'">
          <div class="px-3 lg:px-10 pt-10 pb-2">
            <button
              class="bg-blues hover:bg-blue-600 text-xs font-bold text-white px-5 py-1.5 rounded-full"
              @click="this.is_selected = 'list'"
            >
              Back
            </button>
          </div>
          <!-- <pre>{{ quizdetailsget }}</pre> -->
          <div>
            <form
              ref="addQuizRefs"
              @submit.prevent="updateQuizOfSection(quizdetailsget.id)"
              class="px-3 lg:px-10 mt-5 pb-2"
            >
              <!-- Fixed draggable configuration -->

              <draggable
                v-model="quizdetailsget.questions"
                item-key="id"
                class="dragArea list-group !w-full"
                @change="onReorder"
                :animation="200"
                handle=".drag-handle"
                ghost-class="ghost"
                chosen-class="chosen"
                :force-fallback="true"
                :scroll-sensitivity="80"
                :scroll-speed="2"
                :bubble-scroll="true"
              >
                <transition-group tag="div" type="transition" class="flip-list">
                  <div
                    v-for="(form, index) in quizdetailsget.questions"
                    :key="form.id || `temp-${index}`"
                    class="w-full mt-3 bg-gray-200 rounded-lg p-4"
                  >
                    <div class="flex flex-col gap-5">
                      <div
                        class="flex items-center justify-between bg-primary px-6 py-3 rounded-t-lg w-full group"
                      >
                        <div class="flex items-center gap-2">
                          <!-- Drag handle with better visibility -->
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            class="w-5 h-5 text-white cursor-move drag-handle"
                            title="Drag to reorder"
                          >
                            <circle cx="5" cy="5" r="1.5" />
                            <circle cx="12" cy="5" r="1.5" />
                            <circle cx="5" cy="12" r="1.5" />
                            <circle cx="12" cy="12" r="1.5" />
                            <circle cx="5" cy="19" r="1.5" />
                            <circle cx="12" cy="19" r="1.5" />
                          </svg>
                          <label class="text-lg text-white"
                            >Question {{ index + 1 }}
                          </label>
                        </div>

                        <button
                          v-if="form.id"
                          type="button"
                          class="bg-red-500 hover:bg-red-600 text-xs text-white rounded-md px-3 py-1"
                          @click="
                            (popupwindowquestiondelete = form.id),
                              (titlepass = form.question_text)
                          "
                        >
                          Remove Question
                        </button>

                        <button
                          v-else
                          type="button"
                          class="bg-red-700 hover:bg-red-800 text-xs text-white rounded-md px-3 py-1"
                          @click="removeFormUpdate(index)"
                        >
                          Remove Question
                        </button>
                      </div>

                      <div class="px-4 sm:px-6 py-2">
                        <textarea
                          v-model="form.question_text"
                          rows="2"
                          required
                          class="p-2 sm:p-4 md:p-4 rounded-md w-full text-sm sm:text-base"
                          placeholder="Enter your question"
                        >
                        </textarea>
                      </div>
                    </div>

                    <!-- Question Type Selection -->
                    <div
                      class="flex items-center gap-2 px-4 sm:px-6 py-2"
                      v-if="quizdetailsget.lesson_quize == true"
                    >
                      <!-- Limited options for lesson quiz -->
                    </div>

                    <div
                      class="flex items-center gap-2 px-4 sm:px-6 py-2"
                      v-else
                    >
                      <input
                        type="radio"
                        value="choice"
                        v-model="form.choice_type"
                      />
                      Choice Type

                      <div>
                        <input
                          type="radio"
                          value="truefalse"
                          v-model="form.choice_type"
                        />
                        True or False
                      </div>
                      <div>
                        <input
                          type="radio"
                          value="matchthefollowing"
                          v-model="form.choice_type"
                        />
                        Match the following
                      </div>

                      <input
                        type="radio"
                        value="shortdescription"
                        v-model="form.choice_type"
                      />
                      Short Answer
                      <input
                        type="radio"
                        value="description"
                        v-model="form.choice_type"
                      />
                      Long Answer
                    </div>

                    <!-- Choice Type -->
                    <div
                      v-if="form.choice_type == 'choice'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <div
                        v-for="(address, addrIndex) in form.answers"
                        :key="addrIndex"
                        class="flex flex-wrap items-center gap-3 py-2"
                      >
                        <label class="text-sm text-gray-700"
                          >Option {{ addrIndex + 1 }}:</label
                        >
                        <input
                          type="text"
                          v-model="address['answer_text']"
                          class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                          placeholder="Enter your option"
                          required
                        />
                        <input
                          type="checkbox"
                          v-model="address['is_correct']"
                          class="w-4 h-4"
                        />
                        <label class="text-sm">Is Answer</label>
                      </div>
                      <button
                        type="button"
                        @click="addMoreChoiceTypeUpdate(index)"
                        class="bg-blues hover:bg-blue-600 text-sm text-white rounded-md px-4 py-2"
                      >
                        Add More
                      </button>
                      <input
                        type="number"
                        required
                        v-model="form.max_mark"
                        class="py-2 px-4 text-sm text-gray-500 rounded-md"
                        placeholder="Add Mark"
                      />
                      <!-- readonly
                      :class="[
                          'flex-1 border rounded-md p-2 text-sm',
                          'bg-gray-100 text-gray-500  outline-none',
                        ]" -->
                    </div>

                    <!-- Short Description -->
                    <div
                      v-if="form.choice_type == 'shortdescription'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <input
                        type="number"
                        required
                        v-model="form.max_mark"
                        class="flex-1 border rounded-md p-2 text-sm"
                        placeholder="Add Mark"
                      />
                    </div>
                    <div
                      v-if="form.choice_type == 'coding'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <label
                        for="language"
                        class="text-sm font-semibold text-gray-700"
                      >
                        Select Programming Language:
                      </label>
                      <select
                        id="language"
                        v-model="form.programming_language"
                        class="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option disabled value="">Select Language</option>
                        <option value="python">Python</option>
                        <!-- <option value="java">Java</option> -->
                        <option value="cpp">C++</option>
                        <option value="c">C</option>
                        <!-- <option value="javascript">JavaScript</option> -->
                      </select>
                    </div>
                    <!-- Description -->
                    <div
                      v-if="form.choice_type == 'description'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <input
                        type="number"
                        required
                        v-model="form.max_mark"
                        placeholder="Add Mark"
                        class="flex-1 border rounded-md p-2 text-sm"
                      />
                    </div>

                    <!-- Match the Following -->
                    <div
                      v-if="form.choice_type == 'matchthefollowing'"
                      class="py-3 grid grid-cols-2 gap-2 mt-1 px-6"
                    >
                      <div>
                        <div
                          v-for="(address, addrIndex) in form.matchthefollowing"
                          :key="addrIndex"
                          class="flex flex-wrap items-center gap-3 py-2"
                        >
                          <input
                            type="text"
                            v-model="address.left_text"
                            class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                            placeholder="Enter Left Option"
                            required
                          />
                        </div>
                      </div>
                      <div>
                        <div
                          v-for="(address, addrIndex) in form.matchthefollowing"
                          :key="addrIndex"
                          class="flex flex-wrap items-center gap-3 py-2"
                        >
                          <input
                            type="text"
                            v-model="address.right_text"
                            class="flex-1 border rounded-md p-2 text-sm w-[150px]"
                            placeholder="Enter Right Option"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <!-- True/False -->
                    <div
                      v-if="form.choice_type == 'truefalse'"
                      class="py-3 flex flex-col gap-2 mt-1 px-6"
                    >
                      <div
                        v-for="(address, addrIndex) in form.truefalse"
                        :key="addrIndex"
                        class="flex flex-wrap items-center gap-3 py-2"
                      >
                        <input
                          type="checkbox"
                          v-model="address['is_correct']"
                          class="w-4 h-4"
                        />
                        <label class="text-sm">
                          <span v-if="addrIndex == 0">True</span>
                          <span v-else>False</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </transition-group>
              </draggable>

              <div class="flex justify-end gap-4 mt-4">
                <button
                  type="button"
                  @click="addFormUpdateNew"
                  class="bg-blues hover:bg-blue-600 text-sm text-white rounded-md px-4 py-2"
                >
                  Add Question
                </button>
              </div>

              <div class="flex justify-end mt-4">
                <button
                  type="submit"
                  class="text-white bg-blues hover:bg-blue-600 rounded-lg text-xs px-6 py-2"
                >
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!-- add assesment form  -->
      <div
        v-if="addQuiz"
        @click.self="addQuiz = false"
        class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      >
        <div
          class="w-full max-w-lg bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto"
          style="scrollbar-width: thin"
        >
          <!-- Header -->
          <div
            class="sticky top-0 z-10 bg-white/95 px-6 py-4 border-b border-gray-100"
          >
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-2.5">
                <h3
                  class="text-base font-bold text-gray-800 flex items-center gap-2"
                >
                  Course Quiz
                </h3>
              </div>

              <button
                @click="closeQuizPopup"
                class="p-1.5 rounded hover:bg-gray-100 transition-colors duration-200"
              >
                <svg
                  class="w-4 h-4 text-gray-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>

          <form
            ref="quizAddReff"
            @submit.prevent="checkPercentage"
            class="p-5 space-y-4"
          >
            <!-- File Upload Section -->
            <div class="space-y-2.5">
              <div class="flex items-center justify-between">
                <label
                  class="text-sm font-medium text-gray-700 flex items-center gap-1.5"
                >
                  Attachments
                  <span class="text-red-500">*</span>
                  <div class="relative group inline-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5 text-gray-400 hover:text-blue-500 cursor-pointer transition-colors"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <div
                      class="absolute z-10 hidden group-hover:block w-56 rounded-lg bg-gray-800 p-2.5 text-[10px] text-white top-6 left-1/2 -translate-x-1/2 shadow-lg"
                    >
                      Only xls files in the sample format are allowed.
                      <div
                        class="absolute -top-2 left-1/2 -translate-x-1/2 border-8 border-transparent border-b-gray-800"
                      ></div>
                    </div>
                  </div>
                </label>

                <a
                  href="https://alliance-lms-dev.s3.ap-south-1.amazonaws.com/staticfiles/uploaded_videos/quiz_questions_Y1XzIps3_1_4assbFB.xls"
                  download
                  class="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 text-[10px] font-medium"
                >
                  <svg
                    class="w-3.5 h-3.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    />
                  </svg>
                  Sample File
                </a>
              </div>

              <input
                id="source"
                type="file"
                class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                required
              />
              <p class="text-[10px] text-gray-400">
                Upload XLS file with quiz questions
              </p>
            </div>

            <!-- Verification Toggle -->
            <div
              class="flex items-center gap-2.5 p-2.5 bg-blue-50/50 rounded-lg border border-blue-100"
            >
              <label class="relative inline-flex items-center cursor-pointer">
                <input
                  id="verification_checkbox"
                  type="checkbox"
                  v-model="verificationEnabled"
                  @change="toggleVerification"
                  class="sr-only peer"
                />
                <div
                  class="relative w-9 h-5 bg-gray-200 rounded-full peer-checked:bg-blue-600 peer-focus:ring-2 peer-focus:ring-blue-300 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:w-4 after:h-4 after:bg-white after:border after:border-gray-300 after:rounded-full after:transition-all peer-checked:after:translate-x-4"
                ></div>
              </label>
              <label
                for="verification_checkbox"
                class="text-xs font-medium text-gray-700 cursor-pointer"
              >
                Enable Verification
              </label>
            </div>

            <!-- Verification Percentage -->
            <div v-if="verificationEnabled" class="animate-slideDown">
              <div
                class="flex items-center gap-2.5 p-2.5 bg-blue-50/30 rounded-lg border border-blue-100"
              >
                <label
                  for="verification_percentage"
                  class="text-xs font-medium text-gray-700 whitespace-nowrap"
                >
                  Percentage
                  <span class="text-red-500">*</span>
                </label>
                <div class="relative flex-1 max-w-[100px]">
                  <input
                    id="verification_percentage"
                    v-model="verificationPercentage"
                    type="text"
                    maxlength="2"
                    :required="verificationEnabled"
                    :disabled="!verificationEnabled"
                    class="w-full px-2 py-1.5 bg-white border-2 border-gray-200 rounded-lg text-xs outline-none transition-all duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                    :class="
                      !verificationEnabled &&
                      'bg-gray-100 cursor-not-allowed opacity-60'
                    "
                    placeholder="0-99"
                    @input="
                      verificationPercentage = verificationPercentage
                        .replace(/\D/g, '')
                        .slice(0, 2)
                    "
                  />
                  <span
                    class="absolute right-2 top-1.5 text-[10px] text-gray-400"
                    >%</span
                  >
                </div>
                <span class="text-[10px] text-gray-400">(0-99)</span>
              </div>
            </div>

            <!-- Action Buttons -->

            <div
              class="flex items-center justify-end gap-2 pt-3 border-t border-gray-200 mt-1"
            >
              <button
                type="button"
                @click="closeQuizPopup"
                class="px-4 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                :disabled="disable_submit == true"
                class="px-4 py-1.5 text-xs font-semibold text-white rounded-lg flex items-center gap-2"
                :class="
                  disable_submit
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                "
              >
                <svg
                  v-if="!disable_submit"
                  class="w-3.5 h-3.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {{ disable_submit ? "Submiting..." : "Submit" }}
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-5 h-5 object-contain"
              />
            </div>
          </form>
        </div>
      </div>

      <div
        v-if="showPercentagePopup"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      >
        <div class="bg-white rounded-xl p-6 w-[400px] max-w-[92%] shadow-xl">
          <!-- Header -->
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-2">
              <svg
                class="w-5 h-5 text-yellow-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <h2 class="text-lg font-semibold text-gray-800">Warning</h2>
            </div>
            <button
              @click="cancelPercentageChange"
              class="text-gray-400 hover:text-gray-600"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <!-- Message -->
          <div class="bg-gray-50 rounded-lg p-4 mb-5">
            <p class="text-sm text-gray-700 text-center leading-relaxed">
              Previous course quiz percentage is
              <span
                class="inline-block px-2 py-0.5 mx-1 bg-red-100 text-red-700 font-bold rounded"
              >
                {{ previousPercentage }}%
              </span>
              <br class="sm:hidden" />
              <span class="hidden sm:inline"> </span>
              Do you want to change it to
              <span
                class="inline-block px-2 py-0.5 mx-1 bg-green-100 text-green-700 font-bold rounded"
              >
                {{ verificationPercentage }}%
              </span>
              ?
            </p>
          </div>

          <!-- Buttons -->
          <div
            class="flex flex-col sm:flex-row items-center justify-center gap-3"
          >
            <button
              @click="cancelPercentageChange"
              class="w-full sm:w-auto px-6 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Close
            </button>

            <button
              @click="confirmPercentageChange"
              class="w-full sm:w-auto px-6 py-2 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 shadow-sm"
            >
              OK
            </button>
          </div>
        </div>
      </div>

      <!-- Publish / Unpublish popup -->
      <div
        v-if="publishPopup"
        @click.self="closePublishPopup"
        class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      >
        <div
          class="w-full max-w-md bg-white rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto flex flex-col"
        >
          <!-- Header -->
          <div
            class="sticky top-0 z-10 bg-white/95 px-6 py-4 border-b border-gray-100 flex items-center justify-between"
          >
            <h3 class="text-base font-bold text-gray-800">
              {{ publishTarget.status ? "Publish Quiz" : "Unpublish Quiz" }}
            </h3>
            <button
              @click="closePublishPopup"
              class="p-1.5 rounded hover:bg-gray-100 transition-colors duration-200"
            >
              <svg
                class="w-4 h-4 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div class="p-5 space-y-3">
            <!-- Total count + select all -->
            <div class="flex items-center justify-between">
              <span class="text-xs font-medium text-gray-500">
                Total: {{ studentAllList.length }}
              </span>
              <label
                class="flex items-center gap-1.5 text-xs font-semibold text-gray-700 cursor-pointer"
              >
                <input
                  type="checkbox"
                  v-model="selectAllPublish"
                  @change="toggleSelectAllPublish"
                  class="w-3.5 h-3.5 rounded text-blue-600 border-gray-400"
                />
                Overall
              </label>
            </div>

            <div class="relative">
              <input
                type="text"
                v-model="publishSearching"
                @input="getAllstudentdetails()"
                placeholder="Search students"
                class="w-full pl-4 pr-9 py-2 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-600 text-xs focus:outline-none focus:ring-2 focus:ring-blue-300"
              />
              <button
                v-if="publishSearching"
                type="button"
                @click="
                  publishSearching = '';
                  getAllstudentdetails();
                "
                class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
              >
                <svg
                  class="w-3.5 h-3.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <!-- Student list -->
            <div
              class="border border-gray-200 rounded-lg max-h-52 overflow-y-auto divide-y divide-gray-100"
            >
              <label
                v-for="student in studentAllList"
                :key="student.id"
                class="flex items-center gap-2.5 px-3 py-2 text-xs text-gray-700 hover:bg-gray-50 cursor-pointer"
              >
                <input
                  type="checkbox"
                  :value="student.id"
                  v-model="publishSelectedUsers"
                  class="w-3.5 h-3.5 rounded text-blue-600 border-gray-400"
                />
                <span class="truncate">{{
                  student.display_name || student.email
                }}</span>
              </label>
              <div
                v-if="studentAllList.length === 0"
                class="px-3 py-4 text-center text-xs text-gray-400"
              >
                No students found
              </div>
            </div>

            <!-- Selected count -->
            <div
              v-if="publishSelectedUsers.length > 0"
              class="text-[11px] font-medium text-blue-700 bg-blue-50 inline-block px-3 py-1 rounded-full"
            >
              Selected: {{ publishSelectedUsers.length }}
            </div>
          </div>

          <!-- Footer -->
          <div
            class="flex items-center justify-end gap-2 px-5 pb-5 pt-3 border-t border-gray-100"
          >
            <button
              type="button"
              @click="closePublishPopup"
              class="px-4 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Cancel
            </button>
            <button
              type="button"
              :disabled="disable_submit || publishSelectedUsers.length === 0"
              @click="confirmPublish"
              class="px-4 py-1.5 text-xs font-semibold text-white rounded-lg"
              :class="
                disable_submit || publishSelectedUsers.length === 0
                  ? 'bg-gray-400 cursor-not-allowed'
                  : 'bg-blue-600 hover:bg-blue-700'
              "
            >
              {{ disable_submit ? "Submiting..." : "Submit" }}
            </button>
          </div>
        </div>
      </div>

      <div
        v-if="this.addLessonQuiz"
        @click.self="this.addLessonQuiz = false"
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      >
        <div
          class="2xl:w-[20%] md:w-[55%] w-[92%] bg-white rounded-2xl shadow-2xl p-4 overflow-y-auto max-h-[90vh]"
        >
          <!-- Header with close button -->
          <div
            class="flex items-center justify-between mb-3 pb-2 border-b border-gray-100"
          >
            <h3
              class="text-base font-bold text-gray-800 flex items-center gap-2"
            >
              Lesson Quiz
            </h3>

            <button
              @click="this.addLessonQuiz = false"
              class="p-1.5 rounded hover:bg-gray-100 transition-colors duration-200"
            >
              <svg
                class="w-4 h-4 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div class="w-full mt-2 flex flex-col relative">
            <div class="w-full">
              <form
                ref="quizAddReff"
                @submit.prevent="QuizLessonPost"
                class="flex flex-col gap-3 text-xs md:text-sm lg:text-base"
              >
                <div class="w-full flex flex-col gap-1">
                  <div class="flex items-center justify-between">
                    <label
                      for="section_id"
                      class="text-sm font-semibold text-gray-700 flex items-center gap-1"
                    >
                      Section <span class="text-red-500">*</span>
                    </label>
                  </div>

                  <div class="relative">
                    <select
                      id="section_id"
                      required
                      class="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-xs text-gray-700 outline-none appearance-none cursor-pointer hover:border-gray-400 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 pr-8"
                    >
                      <option value="" disabled selected>Select Section</option>
                      <option
                        v-for="section in sectionInfo"
                        :key="section.id"
                        :value="section.id"
                      >
                        {{ section.title }}
                      </option>
                    </select>

                    <div
                      class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none"
                    >
                      <svg
                        class="w-4 h-4 text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <!-- File Upload Section -->
                <div class="flex flex-col gap-2 w-full">
                  <div class="flex items-center justify-between">
                    <label
                      for="attachments"
                      class="text-sm font-semibold text-gray-700 flex items-center gap-1.5"
                    >
                      Attachments <span class="text-red-500">*</span>
                      <div class="relative group inline-block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-3.5 w-3.5 text-gray-400 hover:text-blue-500 cursor-pointer transition-colors"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-56 rounded-lg bg-gray-800 p-2.5 text-[10px] text-white top-6 left-1/2 -translate-x-1/2 shadow-lg"
                        >
                          Only xls files in the sample format are allowed.
                          <div
                            class="absolute -top-2 left-1/2 -translate-x-1/2 border-8 border-transparent border-b-gray-800"
                          ></div>
                        </div>
                      </div>
                    </label>
                    <a
                      href="https://alliance-lms.s3.ap-south-1.amazonaws.com/media/uploaded_videos/lesson_quiz_bulk_upload_oDO2mdZ_Ws7ooHJ_dQ3ufpO.xls"
                      download
                      class="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 text-[10px] font-medium"
                    >
                      <svg
                        class="w-3.5 h-3.5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                        />
                      </svg>
                      Sample File
                    </a>
                  </div>

                  <div class="relative">
                    <input
                      id="lessonsource"
                      name="lessonsource"
                      type="file"
                      class="w-full border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 file:mr-3 file:py-1 file:px-3 file:rounded-lg file:border-0 file:bg-blue-50 file:text-blue-600 file:text-xs hover:file:bg-blue-100"
                      required
                    />
                  </div>
                  <p class="text-[10px] text-gray-400">
                    Upload XLS file with quiz questions
                  </p>
                </div>

                <!-- Action Buttons -->

                <div
                  class="flex items-center justify-end gap-2 pt-3 border-t border-gray-200 mt-1"
                >
                  <button
                    type="button"
                    @click="this.addLessonQuiz = false"
                    class="px-4 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    :disabled="disable_submit == true"
                    class="px-4 py-1.5 text-xs font-semibold text-white rounded-lg flex items-center gap-2"
                    :class="
                      disable_submit
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-blue-600 hover:bg-blue-700'
                    "
                  >
                    <svg
                      v-if="!disable_submit"
                      class="w-3.5 h-3.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                    {{ disable_submit ? "Submiting..." : "Submit" }}
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-5 h-5 object-contain"
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="popUpQuiz"
        @click.self="popUpQuiz = false"
        class="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center"
      >
        <div
          class="2xl:w-[30%] md:w-[70%] w-[92%] bg-white rounded-xl p-5 max-h-[90vh] overflow-y-auto"
        >
          <div
            class="flex items-center justify-between pb-3 border-b border-gray-200"
          >
            <h3
              class="text-base font-bold text-gray-800 flex items-center gap-2"
            >
              <svg
                class="w-4 h-4 text-blue-600"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
              Edit Quiz
            </h3>
            <button
              @click="popUpQuiz = false"
              class="p-1.5 rounded hover:bg-gray-100"
            >
              <svg
                class="w-4 h-4 text-gray-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <form
            ref="addQuizRefs"
            @submit.prevent="checkEditPercentage"
            class="flex flex-col gap-3 mt-3"
          >
            <div class="grid grid-cols-1 gap-3">
              <div class="flex flex-col gap-1">
                <label for="title" class="text-xs font-medium text-gray-700">
                  Title <span class="text-red-500">*</span>
                </label>
                <input
                  v-if="quizdetailsget.lesson_quize == false"
                  id="title"
                  type="text"
                  v-model="quizdetailsget.name"
                  required
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  placeholder="Enter title"
                />
                <input
                  v-else
                  id="title"
                  type="text"
                  v-model="quizdetailsget.lesson_title"
                  required
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  placeholder="Enter lesson title"
                />
              </div>

              <div class="flex flex-col gap-1">
                <label for="content" class="text-xs font-medium text-gray-700">
                  Description <span class="text-red-500">*</span>
                </label>
                <textarea
                  id="content"
                  rows="3"
                  type="text"
                  v-model="quizdetailsget.description"
                  required
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none resize-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                  placeholder="Enter description"
                ></textarea>
              </div>

              <div class="flex flex-col gap-1">
                <label for="duration" class="text-xs font-medium text-gray-700">
                  Test Duration (Minutes) <span class="text-red-500">*</span>
                </label>
                <input
                  id="duration"
                  v-model="quizdetailsget.timer"
                  type="number"
                  required
                  class="border border-gray-300 rounded-lg text-xs px-3 py-2 outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                />
              </div>

              <div
                class="flex flex-col gap-1 bg-gray-50 p-2.5 rounded-lg border border-gray-100"
              >
                <div class="flex items-center gap-3">
                  <label
                    for="maxquestion"
                    class="text-xs font-medium text-gray-700 whitespace-nowrap w-[100px]"
                  >
                    Max Questions
                  </label>
                  <input
                    id="maxquestion"
                    type="number"
                    v-model.number="quizdetailsget.max_questions"
                    @input="handleMaxQuestionInput"
                    class="w-20 px-2 py-1 border rounded-lg text-xs outline-none"
                    :class="{
                      'border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500':
                        !maxQuestionError,
                      'border-red-500 focus:ring-1 focus:ring-red-500 focus:border-red-500':
                        maxQuestionError,
                    }"
                    min="1"
                  />
                  <span class="text-xs font-semibold text-gray-500">
                    / {{ quizdetailsget?.questions?.length || 0 }} total
                    questions
                  </span>
                </div>
                <p
                  v-if="maxQuestionError"
                  class="text-red-500 text-[11px] mt-1 pl-[112px]"
                >
                  Cannot exceed total questions ({{
                    quizdetailsget?.questions?.length || 0
                  }}).
                </p>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 pt-1">
                <div class="flex items-center gap-2">
                  <input
                    id="question_attempt"
                    type="checkbox"
                    v-model="quizdetailsget.question_attempt"
                    class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300"
                  />
                  <label
                    for="question_attempt"
                    class="text-xs font-medium text-gray-700 cursor-pointer"
                  >
                    Multiple Attempts
                  </label>
                </div>

                <div
                  v-if="quizdetailsget.question_attempt"
                  class="flex items-center gap-2"
                >
                  <label
                    for="question_attempt_count"
                    class="text-xs font-medium text-gray-700 whitespace-nowrap"
                  >
                    Attempt Count <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="question_attempt_count"
                    v-model="quizdetailsget.question_attempt_count"
                    type="text"
                    maxlength="2"
                    required
                    class="w-20 px-2 py-1.5 border border-gray-300 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 bg-white"
                    placeholder="0-99"
                    @input="
                      quizdetailsget.question_attempt_count =
                        quizdetailsget.question_attempt_count
                          .replace(/\D/g, '')
                          .slice(0, 2)
                    "
                  />
                </div>
              </div>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3 pt-1">
                <div
                  v-if="quizdetailsget.lesson_quize == false"
                  class="flex items-center gap-2"
                >
                  <input
                    id="verification_checkbox"
                    type="checkbox"
                    v-model="quizdetailsget.internal_verification"
                    @change="toggleVerification"
                    class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300"
                  />
                  <label
                    for="verification_checkbox"
                    class="text-xs font-medium text-gray-700 cursor-pointer"
                  >
                    Enable Verification
                  </label>
                </div>

                <div
                  v-if="quizdetailsget.internal_verification"
                  class="flex items-center gap-2"
                >
                  <label
                    for="verification_percentage"
                    class="text-xs font-medium text-gray-700 whitespace-nowrap"
                  >
                    Percentage <span class="text-red-500">*</span>
                  </label>
                  <input
                    id="verification_percentage"
                    v-model="quizdetailsget.total_persentage"
                    type="text"
                    maxlength="2"
                    required
                    class="w-20 px-2 py-1.5 border border-gray-300 rounded-lg text-xs outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 bg-white"
                    placeholder="0-99"
                    @input="
                      quizdetailsget.total_persentage =
                        quizdetailsget.total_persentage
                          .replace(/\D/g, '')
                          .slice(0, 2)
                    "
                  />
                </div>
              </div>

              <div class="flex items-center gap-2">
                <input
                  id="question_shuffle"
                  type="checkbox"
                  v-model="quizdetailsget.shuffle"
                  class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300"
                />
                <label
                  for="question_shuffle"
                  class="text-xs font-medium text-gray-700 cursor-pointer"
                >
                  Shuffle Questions
                </label>
              </div>

              <div class="flex items-center gap-2">
                <input
                  id="quiz_feedback"
                  type="checkbox"
                  v-model="quizdetailsget.quizsfeedback"
                  class="w-3.5 h-3.5 text-blue-600 rounded border-gray-300"
                />
                <label
                  for="quiz_feedback"
                  class="text-xs font-medium text-gray-700 cursor-pointer"
                >
                  Enable Feedback
                </label>
              </div>
            </div>

            <div
              class="flex items-center justify-end gap-2 pt-3 border-t border-gray-200 mt-2"
            >
              <button
                type="button"
                @click="popUpQuiz = false"
                class="px-4 py-1.5 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                type="submit"
                :disabled="disable_submit == true"
                class="px-4 py-1.5 text-xs font-semibold text-white rounded-lg flex items-center gap-2"
                :class="
                  disable_submit
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                "
              >
                <svg
                  v-if="!disable_submit"
                  class="w-3.5 h-3.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
                {{ disable_submit ? "Saving..." : "Save" }}
              </button>
              <img
                v-if="disable_submit"
                src="@/assets/loading.gif"
                alt="loading"
                class="w-5 h-5 object-contain"
              />
            </div>
          </form>
        </div>
      </div>
      <div
        v-if="showeditPercentagePopup"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      >
        <div class="bg-white rounded-xl p-6 w-[400px] max-w-[92%] shadow-xl">
          <!-- Header -->
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center gap-2">
              <svg
                class="w-5 h-5 text-yellow-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
              <h2 class="text-lg font-semibold text-gray-800">Warning</h2>
            </div>
            <button
              @click="canceleditPercentageChange"
              class="text-gray-400 hover:text-gray-600"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <!-- Message -->
          <div class="bg-gray-50 rounded-lg p-4 mb-5">
            <p class="text-sm text-gray-700 text-center leading-relaxed">
              Previous course quiz percentage is
              <span
                class="inline-block px-2 py-0.5 mx-1 bg-red-100 text-red-700 font-bold rounded"
              >
                {{ previousPercentage }}%
              </span>
              <br class="sm:hidden" />
              <span class="hidden sm:inline"> </span>
              Do you want to change it to
              <span
                class="inline-block px-2 py-0.5 mx-1 bg-green-100 text-green-700 font-bold rounded"
              >
                {{ quizdetailsget.total_persentage }}%
              </span>
              ?
            </p>
          </div>

          <!-- Buttons -->
          <div
            class="flex flex-col sm:flex-row items-center justify-center gap-3"
          >
            <button
              @click="canceleditPercentageChange"
              class="w-full sm:w-auto px-6 py-2 text-sm font-medium text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Close
            </button>

            <button
              @click="confirmeditPercentageChange"
              class="w-full sm:w-auto px-6 py-2 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 shadow-sm"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
    <ServerError v-if="server_error" @close="closeError" />
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";

import ConfirmPopup from "@/components/ConfirmPopup.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import ServerError from "@/components/ServerError.vue";
import { VueDraggableNext } from "vue-draggable-next";
import axios from "axios";
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";
import router from "@/router";

export default {
  components: {
    Header,
    SideBar,
    ConfirmPopup,
    FlashMessage,
    ServerError,
    draggable: VueDraggableNext,
    Pagination,
  },
  data() {
    return {
      currentPage: 1,
      totalPages: 1,
      updateDetails: "",
      not_attended: 0,
      current_coursename: "",
      scoredetails: "",
      published: "",
      popupwindow: false,
      titlepass: "",
      is_selected: "list",
      quiz_id: 0,
      generalquiz: [],
      messages: {
        text: "",
        type: "null",
      },
      addQuiz: false,
      addLessonQuiz: false,
      loading: true,
      quizdetailsget: [],
      popUpAction: null,
      typeQuiz: "course",
      editQuizId: null,
      active_tab: "Course Quiz",
      server_error: false,
      popupwindowquestiondelete: null,
      disable_submit: false,
      editAttempt: null,
      popUpQuiz: false,
      response_message: "",
      searchValue: "",
      sectionInfo: [],
      shuffled: "",
      quizsearch: "",
      fileInfo: "",
      verificationEnabled: false,
      verificationPercentage: "",
      previousmark: {},
      previousPercentage: "",
      showPercentagePopup: false,
      pendingForm: null,
      editPendingId: null,
      isEditMode: false,
      showeditPercentagePopup: false,
      publishPopup: false,
      selectAllPublish: false,
      publishTarget: {
        id: null,
        name: "",
        order: null,
        status: false,
      },
      publishSearching: "",
      publishSelectedUsers: [],
      studentAllList: [],
      studentcount: 0,
    };
  },

  created() {
    this.getpercentage();
    this.sectionInfoGet();
    this.quizgetinfo();
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
    maxQuestionError() {
      const questions = this.quizdetailsget?.questions || [];
      const max = this.quizdetailsget?.max_questions;

      return max !== null && max > questions.length;
    },
  },

  watch: {
    publishSelectedUsers() {
      this.selectAllPublish =
        this.studentAllList.length > 0 &&
        this.publishSelectedUsers.length === this.studentAllList.length;
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    checkEditPercentage() {
      if (
        this.previousPercentage &&
        this.quizdetailsget.internal_verification &&
        this.previousPercentage != this.quizdetailsget.total_persentage
      ) {
        this.editPendingId = this.quizdetailsget.id;
        this.isEditMode = true;
        this.showeditPercentagePopup = true;
        return;
      }

      this.editQuizContent(this.quizdetailsget.id);
    },
    confirmeditPercentageChange() {
      this.showeditPercentagePopup = false;

      if (this.isEditMode) {
        this.editQuizContent(this.editPendingId);
      } else {
        this.QuizPost(this.pendingForm);
      }

      this.isEditMode = false;
    },
    canceleditPercentageChange() {
      this.showeditPercentagePopup = false;
      this.pendingForm = null;
      this.editPendingId = null;
      this.isEditMode = false;
    },
    async checkPercentage(el) {
      if (
        this.previousPercentage &&
        this.verificationEnabled &&
        this.previousPercentage != this.verificationPercentage
      ) {
        this.pendingForm = el;
        this.showPercentagePopup = true;
        return;
      }

      this.QuizPost(el);
    },
    confirmPercentageChange() {
      this.showPercentagePopup = false;
      this.QuizPost(this.pendingForm);
    },
    cancelPercentageChange() {
      this.showPercentagePopup = false;
      this.pendingForm = null;
    },
    closeQuizPopup() {
      this.addQuiz = false;

      this.verificationEnabled = false;
      this.verificationPercentage = "";

      this.disable_submit = false;
      this.loading = false;

      this.$refs.quizAddReff.reset();
    },
    async getpercentage() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/skill-percentage-list/?course__id=${this.course_id}&Key=${this.userInfo.token_key}&title=Assessment`,
        )
        .then((response) => {
          if (response.status == 200) {
            this.previousmark = response.data?.data?.data?.data[0];
            this.previousPercentage = this.previousmark?.percentage || "";

            this.verificationEnabled = false;
            this.verificationPercentage = "";
          } else {
            console.log("catch error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleVerification() {
      if (this.verificationEnabled) {
        this.verificationPercentage = this.previousPercentage;
      } else {
        this.verificationPercentage = "";
      }
    },
    async downloadFile() {
      this.loading = true;
      const lessonQuize = this.typeQuiz === "lesson";

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/coursequiz/download/?lesson_quize=${lessonQuize}&course=${this.course_id}&Key=${this.userInfo.token_key}`,
        );

        if (response.status == 200) {
          this.fileInfo = response.data.data;
          this.response_message =
            "Your file is ready to download go to download history page";

          setTimeout(() => {
            this.response_message = "";
          }, 5000);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    async sectionInfoGet() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/section/?course_name=${this.course_id}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.status == 200) {
            this.sectionInfo = response.data.data;
          } else {
            console.log("catch error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleMaxQuestionInput(e) {
      const val = e.target.value;

      if (val === "" || val === null) {
        this.quizdetailsget.max_questions = null;
        return;
      }

      this.quizdetailsget.max_questions = Number(val);
    },


    formatDateTime(date) {
      const d = new Date(date);

      const formattedDate = d.toLocaleDateString("en-IN", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

      const formattedTime = d
        .toLocaleTimeString("en-IN", {
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: true,
        })
        .toLowerCase();

      return `${formattedDate} - ${formattedTime}`;
    },
    async handleQuizOrderChange() {
      const token_key = this.userInfo.token_key;
      const quizzes = this.generalquiz || [];

      quizzes.forEach((quiz, index) => {
        quiz.order = index + 1;
      });

      for (let quiz of quizzes) {
        const quizId = quiz.quiz?.id;
        if (!quizId) continue;
        console.log("----", this.quizId);
        const orderData = {
          name: quiz.quiz?.name,
          qualify_certificate: quiz.quiz?.qualify_certificate || false,
          order: quiz.order,
        };

        try {
          const response = await axios.put(
            `${process.env.VUE_APP_API}/coursequizpublished/${quizId}/?Key=${token_key}`,
            orderData,
          );
        } catch (error) {
          this.messages = {
            text: "Failed to update quiz order",
            type: "error",
          };
          return;
        }
      }

      this.messages = {
        text: "Quiz order updated successfully",
        type: "success",
      };

      setTimeout(() => {
        this.messages = { text: "", type: "" };
      }, 2000);
    },

    addMoreChoiceTypeUpdate(index) {
      this.quizdetailsget.questions[index].answers.push({
        answer_text: "",
        is_correct: false,
      });
    },
    async onReorder(evt) {
      const token_key = this.userInfo.token_key;
      const questions = this.quizdetailsget.questions || [];
      questions.forEach((question, index) => {
        question.order = index + 1;
      });

      for (let question of questions) {
        if (!question.id) continue;

        const infoDetails = {
          order: question.order,
        };

        try {
          const response = await axios.put(
            `${process.env.VUE_APP_API}/coursequiz/question/${question.id}/?Key=${token_key}`,
            infoDetails,
          );
          console.log("Reorder updated:", response.data);
        } catch (err) {
          console.error("Order update error:", err);
          this.messages = {
            text: "Failed to update question order",
            type: "error",
          };
          return;
        }
      }

      this.messages = {
        text: "Question order updated successfully",
        type: "success",
      };

      setTimeout(() => {
        this.messages = { text: "", type: "" };
      }, 2000);
    },

    handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.popUpAction = null;
      }
    },

    duplicateQuiz(id) {
      this.messages = {
        text: "Quiz Duplicating...",
        type: "success",
      };

      axios
        .get(
          `${process.env.VUE_APP_API}/coursequize/duplication/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            this.messages = {
              text: "Quiz Duplicated successfully",
              type: "success",
            };
            this.quizgetinfo();
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            this.popupwindowquestiondelete = null;
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        });
    },

    async editQuizContent(id) {
      this.disable_submit = true;

      try {
        const response = await axios.put(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
          this.quizdetailsget,
        );

        if (response.data.status === 200) {
          this.getpercentage();
          this.quizgetinfo();
          this.popUpQuiz = false;

          this.messages = {
            text: response.data.message || "Quiz Details Updated Successfully",
            type: "success",
          };
        } else {
          this.messages = {
            text: response.data.message || "Event Failed",
            type: "error",
          };
        }
      } catch (error) {
        this.messages = {
          text: error.response?.data?.message || "Something went wrong.",
          type: "error",
        };
      } finally {
        this.disable_submit = false;

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "",
          };
        }, 3000);
      }
    },
    quizdetailsof_details(id) {
      this.popUpQuiz = true;
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizdetailsget = response.data.data;
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    addFormUpdateNew() {
      this.quizdetailsget.questions.push({
        question_text: "",
        choice_type: "choice",
        answers: [
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
          { answer_text: "", is_correct: false },
        ],
        truefalse: [
          { answer_text: "True", is_correct: false },
          { answer_text: "False", is_correct: false },
        ],
        matchthefollowing: [
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
          { left_text: "", right_text: "" },
        ],
        shortAnswer: "",
        longAnswer: "",
        max_mark: 0,
      });
    },

    removeFormUpdate(index) {
      this.quizdetailsget.questions.splice(index, 1);
    },

    removeQuestion(id) {
      axios
        .delete(
          `${process.env.VUE_APP_API}/coursequiz/question/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response) {
            this.messages = {
              text: "Quiz Deleted successfully",
              type: "success",
            };
            this.quizgetinfo();
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            this.popupwindowquestiondelete = null;
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        });
    },

    closeError() {
      this.server_error = false;
      location.reload();
    },

    PostDataAttempt(id) {
      this.disable_submit = true;
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
          this.quizdetailsget,
        )
        .then((response) => {
          this.disable_submit = false;
          if (response.data.status == 200) {
            this.quizgetinfo();
            this.editAttempt = null;
            this.messages = {
              text: "Quiz Attempt Updated Successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 1000);
        });
    },
    editshuffleContent(id, status) {
      this.disable_submit = true;
      this.shuffled = status;
      let that = this;
      let messagesPass = {
        shuffle: status === false ? true : false,
      };
      axios
        .patch(
          `${process.env.VUE_APP_API}/coursequiz/title/update/${id}/?Key=${this.userInfo.token_key}`,
          messagesPass,
        )
        .then((response) => {
          this.disable_submit = false;
          this.quizgetinfo();
          if (that.shuffled == false) {
            this.editAttempt = null;
            this.messages = {
              text: "Shuffles Enabled Successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          } else {
            this.messages = {
              text: "Shuffles Diasbled Successfully",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 1000);
        });
    },

    PostData(id) {
      this.disable_submit = true;
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
          this.quizdetailsget,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizgetinfo();
            this.editQuizId = null;
            this.messages = {
              text: "Quiz Name Updated Successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          } else {
            this.messages = {
              text: "Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 1000);
        });
    },

    editId(id) {
      this.quizdetailsgetofnone(id);
      if (this.editQuizId == id) {
        this.editQuizId = null;
      } else {
        this.editQuizId = id;
      }
    },

    editIdAttempt(id) {
      this.quizdetailsgetofnone(id);
      if (this.editAttempt == id) {
        this.editAttempt = null;
      } else {
        this.editAttempt = id;
      }
    },

    addOperation(id) {
      if (this.popUpAction == id) {
        this.popUpAction = null;
      } else {
        this.popUpAction = id;
      }
    },

    quizdetailspreview(id) {
      this.is_selected = "preview";
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizdetailsget = response.data.data;
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    updateQuizOfSection(value_id) {
      this.disable_submit = true;
      axios
        .put(
          `${process.env.VUE_APP_API}/coursequiz/${value_id}/?Key=${this.userInfo.token_key}`,
          this.quizdetailsget,
        )
        .then((response) => {
          if (response.data.status == "200") {
            this.messages = {
              text: response.data.message,
              type: "success",
            };

            setTimeout(() => {
              this.is_selected = "detail";
              this.quizgetinfo();
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
    },

    quizdetails(id) {
      this.is_selected = "detail";
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizdetailsget = response.data.data;
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    quizdetailsgetofnone(id) {
      axios
        .get(
          `${process.env.VUE_APP_API}/coursequiz/${id}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizdetailsget = response.data.data;
            console.log(this.quizdetailsget);

            this.loading = false;
          } else {
            this.server_error = true;
          }
        })
        .catch((error) => {
          console.log(error);
          this.server_error = true;
        });
    },

    async QuizPost(el) {
      this.disable_submit = true;
      this.loading = true;

      const file = el.target.elements.source.files[0];

      const HeaderVal = new FormData();
      HeaderVal.append("my_file", file);
      HeaderVal.append(
        "verification",
        this.verificationEnabled ? "True" : "False",
      );
      HeaderVal.append("percentage", this.verificationPercentage);

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/excelcourse_question_answer_new/${this.course_id}/?Key=${this.userInfo.token_key}`,
          HeaderVal,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response.data.status === 200) {
          this.messages = {
            text: "Course Quiz added successfully",
            type: "success",
          };

          this.popUpLesson = false;
          this.addQuiz = false;
          this.$refs.quizAddReff.reset();
          this.quizgetinfo();
          this.getpercentage();
        } else {
          this.messages = {
            text: response.data.message || "Event Failed",
            type: "error",
          };
        }
      } catch (error) {
        this.messages = {
          text: error.response?.data?.message || "Something went wrong.",
          type: "error",
        };
      } finally {
        this.disable_submit = false;
        this.loading = false;

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "",
          };
          this.questionAnswer = [];
          this.quizCourse = null;
        }, 2000);
      }
    },
    async QuizLessonPost(el) {
      this.disable_submit = true;
      this.loading = true;

      const formElements = el.target.elements;
      const sectionId = Number(formElements.section_id.value);
      const file = formElements.lessonsource.files[0];

      const formData = new FormData();
      formData.append("file", file);
      formData.append("section_id", sectionId);

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/lesson/bulk-upload/${this.course_id}/?Key=${this.userInfo.token_key}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response.data.status === 200) {
          this.messages = {
            text: response.data.message || "Lesson Quiz added successfully",
            type: "success",
          };

          this.$refs.quizAddReff.reset();
          this.popUpLesson = false;
          this.addLessonQuiz = false;
          this.quizgetinfo();
        } else {
          this.messages = {
            text: response.data.message || "Event Failed",
            type: "error",
          };
        }
      } catch (error) {
        this.messages = {
          text: error.response?.data?.message || "Something went wrong.",
          type: "error",
        };
      } finally {
        this.disable_submit = false;
        this.loading = false;

        setTimeout(() => {
          this.messages = {
            text: "",
            type: "",
          };
          this.questionAnswer = [];
          this.quizCourse = null;
        }, 2000);
      }
    },

    async quizgetinfo() {
      this.loading = true;
      this.is_selected = "list";
      this.generalquiz = [];
      if (this.typeQuiz == "course") {
        await axios
          .get(
            `${process.env.VUE_APP_API}/course_quizzes_detail/${this.course_id}/?Key=${this.userInfo.token_key}&search=${this.quizsearch}`,
          )
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.generalquiz = response.data.data;
              this.loading = false;
              this.published = this.generalquiz;
              console.log(this.published);
            } else if (response.data.status == 400) {
              this.loading = false;
            } else {
              this.loading = false;
            }
          });
      }
      if (this.typeQuiz == "lesson") {
        await axios
          .get(
            `${process.env.VUE_APP_API}/lesson_quizzes_detail/${this.course_id}/?Key=${this.userInfo.token_key}&search=${this.quizsearch}`,
          )
          .then((response) => {
            this.loading = false;
            if (response.data.data) {
              this.generalquiz = response.data.data;
              this.loading = false;
              this.published = this.generalquiz;
              console.log(this.published);
            } else if (response.data.status == 400) {
              this.loading = false;
            } else {
              this.loading = false;
            }
          });
      }
    },

    async quizget(course_name) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/coursequizdownloadattemptcount/${course_name}/?Key=${this.userInfo.token_key}`,
        );

        if (response.data) {
          this.messages = {
            text: response.data.message,
            type: "success",
          };
        } else {
          this.messages = {
            text: "Error failed",
            type: "error",
          };
        }

        setTimeout(() => {
          this.messages = { text: "", type: "" };
          this.$router.push({
            name: "DownloadHistory",
          });
        }, 3000);
      } catch (error) {
        console.error(error);
        this.messages = {
          text: "Request failed. Please try again.",
          type: "error",
        };
        setTimeout(() => {
          this.messages = { text: "", type: "" };
        }, 3000);
      }
    },

    async quiz_published(coursequizname, name, order, status) {
      this.disable_submit = true;
      this.published = status;
      let that = this;
      let messagesPass = {
        name: name,
        order: order,
        qualify_certificate: status,
      };
      await axios
        .put(
          `${process.env.VUE_APP_API}/coursequizpublished/${coursequizname}/?Key=${this.userInfo.token_key}`,
          messagesPass,
        )
        .then((response) => {
          this.publishedquiz = response.data;
          if (response.data.status == 200) {
            this.quizgetinfo();
            if (that.published == true) {
              this.messages = {
                text: "course quiz published successfully",
                type: "success",
              };
            } else {
              this.messages = {
                text: "course quiz Unpublished successfully",
                type: "error",
              };
            }

            this.popupwindow = false;
          } else {
            this.messages = {
              text: "Quiz name, description, total score and min score filed check Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "",
        };
      }, 1500);
    },


    QuizDeleted(titlepass) {
      this.disable_submit = true;

      axios
        .delete(
          `${process.env.VUE_APP_API}/coursequizdeleted/${titlepass}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.quizgetinfo();
            this.messages = {
              text: "course Quiz Deleted successfully",
              type: "success",
            };
            this.popupwindow = false;
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        })
        .finally(() => {
          setTimeout(() => {
            this.disable_submit = false;
          }, 3000);
        });
    },

    async fetchdownload() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/trigger-quiz-feedback-download/?course_id=${this.course_id}&quiz_id=${this.current_coursename}&Key=${this.userInfo.token_key}`,
        )
        .then((resp) => {
          if (resp && resp.data.status == 200 && resp.data.download_link) {
            const link = document.createElement("a");
            link.href = resp.data.download_link;
            link.download = "";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
.ghost {
  opacity: 0.5;
}
.chosen {
  cursor: grabbing;
}
.dragArea,
.list-group {
  overflow: visible !important;
}

.drag-handle {
  cursor: grab;
}

.drag-handle:active {
  cursor: grabbing;
}
.drag-handle-quiz:active {
  cursor: grabbing;
}
.drag-handle-quiz {
  cursor: grab;
}
.ghost {
  border: 1px dashed gray;
  opacity: 0.5;
  background: #ffffff;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.flip-list {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}
</style>
